/*@ngInject*/
const UIUserAvatarDirective = function ($rootScope, $stateParams, $timeout, coreMediator, coreConstant, currentSubmissionModel) {

    let linkFunction = function ($scope, $elm, $attrs) {
        $scope.isLoading = false;
        $scope.isMouseEnterInProgress = false;

        $scope.$watch('src', function (newValue) {
            if (newValue) {
                $scope.hasAvatar = !!newValue;
                let base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
                if (base64regex.test($scope.src)) {
                    $scope.underwriterImage = 'data:image/png;base64,' + $scope.src;
                }
            }
        });

        $scope.$watch('userid', function (userid, userIdOrig) {
            let avatarNotLoaded = !$scope.hasAvatar,
                newUserSelected = userid !== userIdOrig;
            if (avatarNotLoaded || newUserSelected) {
                loadProfileImage(userid);
            }
        });

        $scope.mouseEnter = function (event) {
            if (!$rootScope.isBusinessCardFreezed) {
                $scope.isMouseEnterInProgress = true;
                $scope.mouseEnterTimer = $timeout(function () {
                    if ($scope.isMouseEnterInProgress) {
                        $scope.showBusinessCard(event);
                    }
                    $scope.isMouseEnterInProgress = false;
                }, 1000);
            }
        };

        $scope.mouseLeave = function () {
            if (!$rootScope.isBusinessCardFreezed) {
                $timeout.cancel($scope.mouseEnterTimer);
                $scope.isMouseEnterInProgress = false;
                $timeout.cancel($scope.mouseLeaveTimer);
                $scope.mouseLeaveTimer = $timeout(function () {
                    $rootScope.$broadcast(coreConstant.event.HIDE_BUSINESS_CARD);
                }, 1000);
            }
        };

        $scope.$on(coreConstant.event.HIDE_BUSINESS_CARD_ON_DROPDOWN, function () {
            $scope.isMouseEnterInProgress = false;
            $rootScope.$broadcast(coreConstant.event.HIDE_BUSINESS_CARD);
        });

        $scope.avatarClick = function () {
            $rootScope.$broadcast(coreConstant.event.HIDE_BUSINESS_CARD);
        };

        $scope.showBusinessCard = function (event) {
            let avatarUserId = $scope.usersummary ? JSON.parse($scope.usersummary).id : parseInt($scope.userid);
            if (avatarUserId && !$scope.disablebusinesscard) {
              let submissionId = ($scope.submissionid) ? $scope.submissionid : $stateParams.submissionId;
              if (!submissionId && currentSubmissionModel && currentSubmissionModel.getCurrentSubmission()) {
                submissionId = currentSubmissionModel.getCurrentSubmission().id;
              }
              $rootScope.$broadcast(coreConstant.event.SHOW_USER_BUSINESS_CARD, event, $scope.usersummary, parseInt($scope.userid), $scope.isGroup, submissionId, $scope.hasBusinessCard, $scope.notificationId, $scope.chatMessageId, $scope.emailMessageId);
            }else if($scope.organizationId && !$scope.disablebusinesscard){
                $rootScope.$broadcast(coreConstant.event.SHOW_ORGANIZATION_CARD, event, $scope.organizationId);
            }
        };

        $scope.$on(coreConstant.event.USER_AVATAR_RELOAD, function (arg1, userid) {
            let avatarUserId = $scope.usersummary ? JSON.parse($scope.usersummary).id : parseInt($scope.userid);
            if (avatarUserId === userid) {
                loadProfileImage(userid);
            }
        });

        function loadProfileImage(userid) {
            if (userid && parseInt(userid) > 0 && !_.isEqual($scope.isGroup,'true')) {
                coreMediator.loadProfileImage(userid).then(function (underwriterImage) {
                    $scope.hasAvatar = !!underwriterImage;
                    $scope.underwriterImage = 'data:image/png;base64,' + underwriterImage;
                });
            } else {
                $scope.hasAvatar = false;
            }
        }
    };

    return {
        restrict: 'AE',
        scope: {
            src: '@',
            usersummary: '@',
            userid: '@',
            organizationId: '@',
            icon: '@',
            isGroup: '@?',
            hasBusinessCard: '<?',
            submissionid: '@',
            isLoading: '<?',
            disablebusinesscard: '<?',
            disabled: '<?',
            notificationId: '@',
            chatMessageId: '@',
            emailMessageId: '@'
        },
        link: linkFunction,
        templateUrl: '/ui/avatar/uiUserAvatar.tpl.html'
    };
};

angular.module('umCore')
    .directive('uiUserAvatar', UIUserAvatarDirective);
